import type { FaireProductEntity } from "../../entity_types/product";

export const p_vg6rvevpa6: FaireProductEntity = {
  token: "p_vg6rvevpa6",
  type: "product",
  name: "EUPHORIA REED DIFFUSER",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/6e1fad0fa7d7a91185cd746be359eb9c4f32bec85239efbc71f20aef663059f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab03b5ea3a58040d7728686b9303bd90b851ed85b689e1f836663d68aa98ce4b.jpeg",
    "https://cdn.faire.com/fastly/3aa66b8ac40cf5abd99b2581ac8bdc63e7173f8485fdb66fa09202d163122719.jpeg"
  ],
  priceDollars: 19,
  description: "Introducing our new reed diffusers! Fill your space with your favorite ROEN scent without the flame.\n\nThe euphoric scent of spring time in the Silver Lake neighborhood of Los Angeles. Blooming bougainvillea cascades along fences while the gorgeous bouquet of night blooming jasmine and osmanthus fill the air. Balanced with exotic white musk and soft undertones of vanilla, this is a floral for both floral lovers and non-floral lovers alike.\n\n• star jasmine, lily, osmanthus, white musk, greens\n\nRoen is hand poured in our Southern California studio. All of our products are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n3 fl oz (88 ml), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:11.688Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
